// global variables
import { agencyPaymentMethod } from 'config';

/**
 * @description
 * Get correct text for an agency payment method
 * @param {string} paymentMethod - Agency payment method.
 * @param {Function} t - Translation.
 * @returns {Object} Correct text.
 */
export default (paymentMethod, t) => {
  switch (paymentMethod) {
    case agencyPaymentMethod.CASH:
      return t('user.info.agency.payment_method.cash');
    case agencyPaymentMethod.CREDIT_CARD:
      return t('user.info.agency.payment_method.credit_card');
    case agencyPaymentMethod.CRYPTO:
      return t('user.info.agency.payment_method.crypto');
    default:
      return null;
  }
};
